import React, {Fragment} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SvgIcon from "@mui/material/SvgIcon";
import Pagination from "@mui/material/Pagination";
import Button from "@mui/material/Button";

import {setLookIntroStep} from "../../../../actions/lookFunctions";
import {LOOK_INTRO_STEPS, LOOK_INTRO_STEPS_MOBILE} from "../../core/constants";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";


const LookIntroBoxSteps = (props) => {

  const {introStep, setLookIntroStep, closeIntro, isMobile} = props;

  const nextButtonClick = () => {
    const nextStep = introStep + 1;
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookIntroNextStep + nextStep);
    setLookIntroStep(nextStep);
  }

  const paginationButtonClick = (event, page) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookIntroPagination + page);
    setLookIntroStep(page);
  }

  const lastStep = isMobile ? LOOK_INTRO_STEPS_MOBILE.review : LOOK_INTRO_STEPS.review;

  return (
    <div className="look-intro__steps">
      <div className="look-intro__steps-buttons">
        {introStep === lastStep ? (
          <Button className="look-button look-button--blue look-button--max look-button--no-transform"
                  variant="outlined" onClick={() => closeIntro(LOOK_JOURNEY_ANALYTIC_EVENTS.lookIntroFinalStepStartDesign)}>
            <FormattedMessage id="look.intro.welcome.buttonSkip"/>
          </Button>
        ) : (
          <Fragment>
            <span className="look-intro__link text-uppercase" onClick={() => {
              closeIntro(LOOK_JOURNEY_ANALYTIC_EVENTS.lookIntroSkip + introStep)
            }}>
              <FormattedMessage id="buttons.skip"/>
            </span>
            <span className="look-intro__link text-uppercase" onClick={nextButtonClick}>
              <FormattedMessage id="buttons.next"/>
              <SvgIcon style={{ fontSize: 22 }}>
                <ChevronRightIcon/>
              </SvgIcon>
            </span>
          </Fragment>
        )}
      </div>
      <div className="look-intro__dots">
        <Pagination count={lastStep}
                    page={introStep}
                    size="small"
                    variant="outlined"
                    color="primary"
                    hidePrevButton
                    hideNextButton
                    onChange={paginationButtonClick}/>
      </div>
    </div>
  )
};

LookIntroBoxSteps.propTypes = {
  closeIntro: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {introStep} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    introStep,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookIntroStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookIntroBoxSteps)
